<template>
  <div class="bg-white rounded-lg p-6 mb-6">
    <div class="flex flex-col md:flex-row items-start justify-between mb-5">
      <div class="flex-1">
        <h1 class="text-3xl font-bold text-gray-900 mb-2">
          {{ displayName }}
        </h1>
        <div class="flex items-center gap-2 my-4 md:my-0 text-gray-600">
          <MapPin :size="20" class="flex-shrink-0" />
          <span>{{ address }}</span>
          <span v-if="subAddress" class="text-gray-400">•</span>
          <span v-if="subAddress" class="text-sm">{{ subAddress }}</span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex items-center gap-2">
        <button
          :class="`p-2 rounded-lg border ${
            isFavorited
              ? 'bg-red-50 border-red-300 text-red-600'
              : 'border-gray-300 text-gray-600 hover:bg-gray-50'
          }`"
          aria-label="Favorite this property"
          @click="toggleFavorite(dealId)"
        >
          <Heart :size="20" :fill="isFavorited ? 'currentColor' : 'none'" />
        </button>
        <button
          class="p-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50"
          aria-label="Copy link to clipboard"
          @click="handleShare"
        >
          <Share2 :size="20" />
        </button>
        <button
          class="p-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50"
          aria-label="Print this page"
          @click="handlePrint"
        >
          <Printer :size="20" />
        </button>
        <!-- TODO -->
        <button
          v-if="false"
          class="p-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50"
        >
          <Flag :size="20" />
        </button>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useFavorites } from '@repo/ui';
import { Heart, Share2, Printer, Flag, MapPin } from 'lucide-vue-next';

const props = defineProps<{
  dealId: string;
  displayName: string;
  address: string;
  subAddress?: string;
}>();

const { isFavorite, toggleFavorite } = useFavorites();
const isFavorited = computed(() => isFavorite(props.dealId));

const handleShare = async () => {
  if (navigator.share) {
    try {
      await navigator.share({
        title: document.title,
        url: window.location.href,
      });
    } catch (error) {
      console.error('Error sharing property:', error);
    }
  } else {
    try {
      await navigator.clipboard.writeText(window.location.href);
      alert('Link copied to clipboard!');
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  }
};

const handlePrint = () => {
  window.print();
};
</script>
